module.exports = __webpack_public_path__ + "static/media/team1Active.12510e8f.svg";